// AIDN unavailable notice — shown when the AIDN_BETA feature flag is disabled
// (globally or for this customer). Replaces the AIDN landing/wizard content
// so the user gets a clear "not available" instead of a broken page.

import { Box, Paper, Stack, Typography } from '@mui/material';
import { IconLock } from '@tabler/icons-react';

export default function AidnUnavailableNotice({ reason }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          p: 4,
          borderRadius: 3,
          border: 1,
          borderColor: 'divider',
          textAlign: 'center'
        }}
      >
        <Stack spacing={2} alignItems="center">
          <IconLock size={48} stroke={1.5} />
          <Typography variant="h4" component="h1">
            AI Defined Network is currently unavailable
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {reason || 'AI Defined Network is currently unavailable. Please try again later.'}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
